export const AiFilterAgentCode = 'hiro_ai_filter_agent';
